import StudentProfile from "@/pages/students/print/student-profile";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/students/$studentId/profile",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <StudentProfile />;
}
